import { TCustomerPayload } from "@ephatta/services"
import _ from "lodash"
import { useEphattaQuery } from "../../.."
import { useCustomerService } from "./useCustomerService"

export const useCustomers = (payload?: TCustomerPayload, config:boolean=true) => {
    const service = useCustomerService()
    return useEphattaQuery(["Customer.Customers", payload], () => service.list(payload!), { enabled: payload !== undefined && config })
} 